module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/default-image.jpg?v=b65b84a0";